import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const countryAutocompleteK = {
  yemen: "country_autocomplete.yemen",
  gabon: "country_autocomplete.gabon",
  lebanon: "country_autocomplete.lebanon",
  liechtenstein: "country_autocomplete.liechtenstein",
  democraticRepublicoftheCongo: "country_autocomplete.democraticRepublicoftheCongo",
  northKorea: "country_autocomplete.northKorea",
  liberia: "country_autocomplete.liberia",
  senegal: "country_autocomplete.senegal",
  gambia: "country_autocomplete.gambia",
  marshallIslands: "country_autocomplete.marshallIslands",
  honduras: "country_autocomplete.honduras",
  nigeria: "country_autocomplete.nigeria",
  barbados: "country_autocomplete.barbados",
  comoros: "country_autocomplete.comoros",
  czechRepublic: "country_autocomplete.czechRepublic",
  philippines: "country_autocomplete.philippines",
  syria: "country_autocomplete.syria",
  greenland: "country_autocomplete.greenland",
  pakistan: "country_autocomplete.pakistan",
  papuaNewGuinea: "country_autocomplete.papuaNewGuinea",
  southAfrica: "country_autocomplete.southAfrica",
  malawi: "country_autocomplete.malawi",
  kosovo: "country_autocomplete.kosovo",
  canada: "country_autocomplete.canada",
  bolivia: "country_autocomplete.bolivia",
  southSudan: "country_autocomplete.southSudan",
  norway: "country_autocomplete.norway",
  mozambique: "country_autocomplete.mozambique",
  netherlands: "country_autocomplete.netherlands",
  kiribati: "country_autocomplete.kiribati",
  saintLucia: "country_autocomplete.saintLucia",
  albania: "country_autocomplete.albania",
  guineaBissau: "country_autocomplete.guineaBissau",
  turkmenistan: "country_autocomplete.turkmenistan",
  eritrea: "country_autocomplete.eritrea",
  mali: "country_autocomplete.mali",
  romania: "country_autocomplete.romania",
  capeVerde: "country_autocomplete.capeVerde",
  palau: "country_autocomplete.palau",
  antiguaandBarbuda: "country_autocomplete.antiguaandBarbuda",
  ghana: "country_autocomplete.ghana",
  cuba: "country_autocomplete.cuba",
  vatican: "country_autocomplete.vatican",
  indonesia: "country_autocomplete.indonesia",
  sriLanka: "country_autocomplete.sriLanka",
  faroeIslands: "country_autocomplete.faroeIslands",
  jordan: "country_autocomplete.jordan",
  myanmar: "country_autocomplete.myanmar",
  azerbaijan: "country_autocomplete.azerbaijan",
  fiji: "country_autocomplete.fiji",
  northMacedonia: "country_autocomplete.northMacedonia",
  turkey: "country_autocomplete.turkey",
  dominica: "country_autocomplete.dominica",
  morocco: "country_autocomplete.morocco",
  guyana: "country_autocomplete.guyana",
  ireland: "country_autocomplete.ireland",
  vanuatu: "country_autocomplete.vanuatu",
  elSalvador: "country_autocomplete.elSalvador",
  italy: "country_autocomplete.italy",
  unitedKingdom: "country_autocomplete.unitedKingdom",
  thailand: "country_autocomplete.thailand",
  sudan: "country_autocomplete.sudan",
  brunei: "country_autocomplete.brunei",
  algeria: "country_autocomplete.algeria",
  luxembourg: "country_autocomplete.luxembourg",
  panama: "country_autocomplete.panama",
  southKorea: "country_autocomplete.southKorea",
  israel: "country_autocomplete.israel",
  cameroon: "country_autocomplete.cameroon",
  saintKittsandNevis: "country_autocomplete.saintKittsandNevis",
  serbia: "country_autocomplete.serbia",
  latvia: "country_autocomplete.latvia",
  croatia: "country_autocomplete.croatia",
  belgium: "country_autocomplete.belgium",
  seychelles: "country_autocomplete.seychelles",
  mauritius: "country_autocomplete.mauritius",
  mauritania: "country_autocomplete.mauritania",
  paraguay: "country_autocomplete.paraguay",
  solomonIslands: "country_autocomplete.solomonIslands",
  swaziland: "country_autocomplete.swaziland",
  dominicanRepublic: "country_autocomplete.dominicanRepublic",
  lesotho: "country_autocomplete.lesotho",
  caymanIslands: "country_autocomplete.caymanIslands",
  france: "country_autocomplete.france",
  russia: "country_autocomplete.russia",
  andorra: "country_autocomplete.andorra",
  macedonia: "country_autocomplete.macedonia",
  switzerland: "country_autocomplete.switzerland",
  montenegro: "country_autocomplete.montenegro",
  germany: "country_autocomplete.germany",
  poland: "country_autocomplete.poland",
  equatorialGuinea: "country_autocomplete.equatorialGuinea",
  qatar: "country_autocomplete.qatar",
  slovenia: "country_autocomplete.slovenia",
  greece: "country_autocomplete.greece",
  unitedArabEmirates: "country_autocomplete.unitedArabEmirates",
  finland: "country_autocomplete.finland",
  uruguay: "country_autocomplete.uruguay",
  malaysia: "country_autocomplete.malaysia",
  burundi: "country_autocomplete.burundi",
  lithuania: "country_autocomplete.lithuania",
  grenada: "country_autocomplete.grenada",
  china: "country_autocomplete.china",
  oman: "country_autocomplete.oman",
  denmark: "country_autocomplete.denmark",
  bangladesh: "country_autocomplete.bangladesh",
  tonga: "country_autocomplete.tonga",
  suriname: "country_autocomplete.suriname",
  saintVincentandtheGrenadines: "country_autocomplete.saintVincentandtheGrenadines",
  sanMarino: "country_autocomplete.sanMarino",
  singapore: "country_autocomplete.singapore",
  hungary: "country_autocomplete.hungary",
  tuvalu: "country_autocomplete.tuvalu",
  uganda: "country_autocomplete.uganda",
  nepal: "country_autocomplete.nepal",
  sierraLeone: "country_autocomplete.sierraLeone",
  centralAfricanRepublic: "country_autocomplete.centralAfricanRepublic",
  republicoftheCongo: "country_autocomplete.republicoftheCongo",
  bosniaandHerzegovina: "country_autocomplete.bosniaandHerzegovina",
  spain: "country_autocomplete.spain",
  saoTomeandPrincipe: "country_autocomplete.saoTomeandPrincipe",
  niger: "country_autocomplete.niger",
  cyprus: "country_autocomplete.cyprus",
  bahrain: "country_autocomplete.bahrain",
  australia: "country_autocomplete.australia",
  uzbekistan: "country_autocomplete.uzbekistan",
  tajikistan: "country_autocomplete.tajikistan",
  haiti: "country_autocomplete.haiti",
  iran: "country_autocomplete.iran",
  kenya: "country_autocomplete.kenya",
  moldova: "country_autocomplete.moldova",
  guatemala: "country_autocomplete.guatemala",
  newZealand: "country_autocomplete.newZealand",
  burkinaFaso: "country_autocomplete.burkinaFaso",
  eastTimor: "country_autocomplete.eastTimor",
  venezuela: "country_autocomplete.venezuela",
  rwanda: "country_autocomplete.rwanda",
  chad: "country_autocomplete.chad",
  belarus: "country_autocomplete.belarus",
  micronesia: "country_autocomplete.micronesia",
  ukraine: "country_autocomplete.ukraine",
  nauru: "country_autocomplete.nauru",
  guinea: "country_autocomplete.guinea",
  jamaica: "country_autocomplete.jamaica",
  kuwait: "country_autocomplete.kuwait",
  somalia: "country_autocomplete.somalia",
  hongKong: "country_autocomplete.hongKong",
  malta: "country_autocomplete.malta",
  estonia: "country_autocomplete.estonia",
  monaco: "country_autocomplete.monaco",
  argentina: "country_autocomplete.argentina",
  yugoslavia: "country_autocomplete.yugoslavia",
  chile: "country_autocomplete.chile",
  brazil: "country_autocomplete.brazil",
  macau: "country_autocomplete.macau",
  georgia: "country_autocomplete.georgia",
  mongolia: "country_autocomplete.mongolia",
  nicaragua: "country_autocomplete.nicaragua",
  ethiopia: "country_autocomplete.ethiopia",
  india: "country_autocomplete.india",
  kazakhstan: "country_autocomplete.kazakhstan",
  madagascar: "country_autocomplete.madagascar",
  slovakia: "country_autocomplete.slovakia",
  colombia: "country_autocomplete.colombia",
  ivoryCoast: "country_autocomplete.ivoryCoast",
  tunisia: "country_autocomplete.tunisia",
  namibia: "country_autocomplete.namibia",
  unitedStates: "country_autocomplete.unitedStates",
  bhutan: "country_autocomplete.bhutan",
  mexico: "country_autocomplete.mexico",
  kyrgyzstan: "country_autocomplete.kyrgyzstan",
  armenia: "country_autocomplete.armenia",
  bahamas: "country_autocomplete.bahamas",
  peru: "country_autocomplete.peru",
  ecuador: "country_autocomplete.ecuador",
  maldives: "country_autocomplete.maldives",
  angola: "country_autocomplete.angola",
  botswana: "country_autocomplete.botswana",
  vietnam: "country_autocomplete.vietnam",
  iraq: "country_autocomplete.iraq",
  trinidadandTobago: "country_autocomplete.trinidadandTobago",
  saudiArabia: "country_autocomplete.saudiArabia",
  japan: "country_autocomplete.japan",
  laos: "country_autocomplete.laos",
  austria: "country_autocomplete.austria",
  afghanistan: "country_autocomplete.afghanistan",
  togo: "country_autocomplete.togo",
  sweden: "country_autocomplete.sweden",
  iceland: "country_autocomplete.iceland",
  bulgaria: "country_autocomplete.bulgaria",
  belize: "country_autocomplete.belize",
  zambia: "country_autocomplete.zambia",
  zimbabwe: "country_autocomplete.zimbabwe",
  egypt: "country_autocomplete.egypt",
  tanzania: "country_autocomplete.tanzania",
  samoa: "country_autocomplete.samoa",
  djibouti: "country_autocomplete.djibouti",
  portugal: "country_autocomplete.portugal",
  cambodia: "country_autocomplete.cambodia",
  costaRica: "country_autocomplete.costaRica",
  taiwan: "country_autocomplete.taiwan",
  benin: "country_autocomplete.benin",
  libya: "country_autocomplete.libya",
};

export const useCountryAutocompleteT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      yemen: t(countryAutocompleteK.yemen),
      gabon: t(countryAutocompleteK.gabon),
      lebanon: t(countryAutocompleteK.lebanon),
      liechtenstein: t(countryAutocompleteK.liechtenstein),
      democraticRepublicoftheCongo: t(countryAutocompleteK.democraticRepublicoftheCongo),
      northKorea: t(countryAutocompleteK.northKorea),
      liberia: t(countryAutocompleteK.liberia),
      senegal: t(countryAutocompleteK.senegal),
      gambia: t(countryAutocompleteK.gambia),
      marshallIslands: t(countryAutocompleteK.marshallIslands),
      honduras: t(countryAutocompleteK.honduras),
      nigeria: t(countryAutocompleteK.nigeria),
      barbados: t(countryAutocompleteK.barbados),
      comoros: t(countryAutocompleteK.comoros),
      czechRepublic: t(countryAutocompleteK.czechRepublic),
      philippines: t(countryAutocompleteK.philippines),
      syria: t(countryAutocompleteK.syria),
      greenland: t(countryAutocompleteK.greenland),
      pakistan: t(countryAutocompleteK.pakistan),
      papuaNewGuinea: t(countryAutocompleteK.papuaNewGuinea),
      southAfrica: t(countryAutocompleteK.southAfrica),
      malawi: t(countryAutocompleteK.malawi),
      kosovo: t(countryAutocompleteK.kosovo),
      canada: t(countryAutocompleteK.canada),
      bolivia: t(countryAutocompleteK.bolivia),
      southSudan: t(countryAutocompleteK.southSudan),
      norway: t(countryAutocompleteK.norway),
      mozambique: t(countryAutocompleteK.mozambique),
      netherlands: t(countryAutocompleteK.netherlands),
      kiribati: t(countryAutocompleteK.kiribati),
      saintLucia: t(countryAutocompleteK.saintLucia),
      albania: t(countryAutocompleteK.albania),
      guineaBissau: t(countryAutocompleteK.guineaBissau),
      turkmenistan: t(countryAutocompleteK.turkmenistan),
      eritrea: t(countryAutocompleteK.eritrea),
      mali: t(countryAutocompleteK.mali),
      romania: t(countryAutocompleteK.romania),
      capeVerde: t(countryAutocompleteK.capeVerde),
      palau: t(countryAutocompleteK.palau),
      antiguaandBarbuda: t(countryAutocompleteK.antiguaandBarbuda),
      ghana: t(countryAutocompleteK.ghana),
      cuba: t(countryAutocompleteK.cuba),
      vatican: t(countryAutocompleteK.vatican),
      indonesia: t(countryAutocompleteK.indonesia),
      sriLanka: t(countryAutocompleteK.sriLanka),
      faroeIslands: t(countryAutocompleteK.faroeIslands),
      jordan: t(countryAutocompleteK.jordan),
      myanmar: t(countryAutocompleteK.myanmar),
      azerbaijan: t(countryAutocompleteK.azerbaijan),
      fiji: t(countryAutocompleteK.fiji),
      northMacedonia: t(countryAutocompleteK.northMacedonia),
      turkey: t(countryAutocompleteK.turkey),
      dominica: t(countryAutocompleteK.dominica),
      morocco: t(countryAutocompleteK.morocco),
      guyana: t(countryAutocompleteK.guyana),
      ireland: t(countryAutocompleteK.ireland),
      vanuatu: t(countryAutocompleteK.vanuatu),
      elSalvador: t(countryAutocompleteK.elSalvador),
      italy: t(countryAutocompleteK.italy),
      unitedKingdom: t(countryAutocompleteK.unitedKingdom),
      thailand: t(countryAutocompleteK.thailand),
      sudan: t(countryAutocompleteK.sudan),
      brunei: t(countryAutocompleteK.brunei),
      algeria: t(countryAutocompleteK.algeria),
      luxembourg: t(countryAutocompleteK.luxembourg),
      panama: t(countryAutocompleteK.panama),
      southKorea: t(countryAutocompleteK.southKorea),
      israel: t(countryAutocompleteK.israel),
      cameroon: t(countryAutocompleteK.cameroon),
      saintKittsandNevis: t(countryAutocompleteK.saintKittsandNevis),
      serbia: t(countryAutocompleteK.serbia),
      latvia: t(countryAutocompleteK.latvia),
      croatia: t(countryAutocompleteK.croatia),
      belgium: t(countryAutocompleteK.belgium),
      seychelles: t(countryAutocompleteK.seychelles),
      mauritius: t(countryAutocompleteK.mauritius),
      mauritania: t(countryAutocompleteK.mauritania),
      paraguay: t(countryAutocompleteK.paraguay),
      solomonIslands: t(countryAutocompleteK.solomonIslands),
      swaziland: t(countryAutocompleteK.swaziland),
      dominicanRepublic: t(countryAutocompleteK.dominicanRepublic),
      lesotho: t(countryAutocompleteK.lesotho),
      caymanIslands: t(countryAutocompleteK.caymanIslands),
      france: t(countryAutocompleteK.france),
      russia: t(countryAutocompleteK.russia),
      andorra: t(countryAutocompleteK.andorra),
      macedonia: t(countryAutocompleteK.macedonia),
      switzerland: t(countryAutocompleteK.switzerland),
      montenegro: t(countryAutocompleteK.montenegro),
      germany: t(countryAutocompleteK.germany),
      poland: t(countryAutocompleteK.poland),
      equatorialGuinea: t(countryAutocompleteK.equatorialGuinea),
      qatar: t(countryAutocompleteK.qatar),
      slovenia: t(countryAutocompleteK.slovenia),
      greece: t(countryAutocompleteK.greece),
      unitedArabEmirates: t(countryAutocompleteK.unitedArabEmirates),
      finland: t(countryAutocompleteK.finland),
      uruguay: t(countryAutocompleteK.uruguay),
      malaysia: t(countryAutocompleteK.malaysia),
      burundi: t(countryAutocompleteK.burundi),
      lithuania: t(countryAutocompleteK.lithuania),
      grenada: t(countryAutocompleteK.grenada),
      china: t(countryAutocompleteK.china),
      oman: t(countryAutocompleteK.oman),
      denmark: t(countryAutocompleteK.denmark),
      bangladesh: t(countryAutocompleteK.bangladesh),
      tonga: t(countryAutocompleteK.tonga),
      suriname: t(countryAutocompleteK.suriname),
      saintVincentandtheGrenadines: t(countryAutocompleteK.saintVincentandtheGrenadines),
      sanMarino: t(countryAutocompleteK.sanMarino),
      singapore: t(countryAutocompleteK.singapore),
      hungary: t(countryAutocompleteK.hungary),
      tuvalu: t(countryAutocompleteK.tuvalu),
      uganda: t(countryAutocompleteK.uganda),
      nepal: t(countryAutocompleteK.nepal),
      sierraLeone: t(countryAutocompleteK.sierraLeone),
      centralAfricanRepublic: t(countryAutocompleteK.centralAfricanRepublic),
      republicoftheCongo: t(countryAutocompleteK.republicoftheCongo),
      bosniaandHerzegovina: t(countryAutocompleteK.bosniaandHerzegovina),
      spain: t(countryAutocompleteK.spain),
      saoTomeandPrincipe: t(countryAutocompleteK.saoTomeandPrincipe),
      niger: t(countryAutocompleteK.niger),
      cyprus: t(countryAutocompleteK.cyprus),
      bahrain: t(countryAutocompleteK.bahrain),
      australia: t(countryAutocompleteK.australia),
      uzbekistan: t(countryAutocompleteK.uzbekistan),
      tajikistan: t(countryAutocompleteK.tajikistan),
      haiti: t(countryAutocompleteK.haiti),
      iran: t(countryAutocompleteK.iran),
      kenya: t(countryAutocompleteK.kenya),
      moldova: t(countryAutocompleteK.moldova),
      guatemala: t(countryAutocompleteK.guatemala),
      newZealand: t(countryAutocompleteK.newZealand),
      burkinaFaso: t(countryAutocompleteK.burkinaFaso),
      eastTimor: t(countryAutocompleteK.eastTimor),
      venezuela: t(countryAutocompleteK.venezuela),
      rwanda: t(countryAutocompleteK.rwanda),
      chad: t(countryAutocompleteK.chad),
      belarus: t(countryAutocompleteK.belarus),
      micronesia: t(countryAutocompleteK.micronesia),
      ukraine: t(countryAutocompleteK.ukraine),
      nauru: t(countryAutocompleteK.nauru),
      guinea: t(countryAutocompleteK.guinea),
      jamaica: t(countryAutocompleteK.jamaica),
      kuwait: t(countryAutocompleteK.kuwait),
      somalia: t(countryAutocompleteK.somalia),
      hongKong: t(countryAutocompleteK.hongKong),
      malta: t(countryAutocompleteK.malta),
      estonia: t(countryAutocompleteK.estonia),
      monaco: t(countryAutocompleteK.monaco),
      argentina: t(countryAutocompleteK.argentina),
      yugoslavia: t(countryAutocompleteK.yugoslavia),
      chile: t(countryAutocompleteK.chile),
      brazil: t(countryAutocompleteK.brazil),
      macau: t(countryAutocompleteK.macau),
      georgia: t(countryAutocompleteK.georgia),
      mongolia: t(countryAutocompleteK.mongolia),
      nicaragua: t(countryAutocompleteK.nicaragua),
      ethiopia: t(countryAutocompleteK.ethiopia),
      india: t(countryAutocompleteK.india),
      kazakhstan: t(countryAutocompleteK.kazakhstan),
      madagascar: t(countryAutocompleteK.madagascar),
      slovakia: t(countryAutocompleteK.slovakia),
      colombia: t(countryAutocompleteK.colombia),
      ivoryCoast: t(countryAutocompleteK.ivoryCoast),
      tunisia: t(countryAutocompleteK.tunisia),
      namibia: t(countryAutocompleteK.namibia),
      unitedStates: t(countryAutocompleteK.unitedStates),
      bhutan: t(countryAutocompleteK.bhutan),
      mexico: t(countryAutocompleteK.mexico),
      kyrgyzstan: t(countryAutocompleteK.kyrgyzstan),
      armenia: t(countryAutocompleteK.armenia),
      bahamas: t(countryAutocompleteK.bahamas),
      peru: t(countryAutocompleteK.peru),
      ecuador: t(countryAutocompleteK.ecuador),
      maldives: t(countryAutocompleteK.maldives),
      angola: t(countryAutocompleteK.angola),
      botswana: t(countryAutocompleteK.botswana),
      vietnam: t(countryAutocompleteK.vietnam),
      iraq: t(countryAutocompleteK.iraq),
      trinidadandTobago: t(countryAutocompleteK.trinidadandTobago),
      saudiArabia: t(countryAutocompleteK.saudiArabia),
      japan: t(countryAutocompleteK.japan),
      laos: t(countryAutocompleteK.laos),
      austria: t(countryAutocompleteK.austria),
      afghanistan: t(countryAutocompleteK.afghanistan),
      togo: t(countryAutocompleteK.togo),
      sweden: t(countryAutocompleteK.sweden),
      iceland: t(countryAutocompleteK.iceland),
      bulgaria: t(countryAutocompleteK.bulgaria),
      belize: t(countryAutocompleteK.belize),
      zambia: t(countryAutocompleteK.zambia),
      zimbabwe: t(countryAutocompleteK.zimbabwe),
      egypt: t(countryAutocompleteK.egypt),
      tanzania: t(countryAutocompleteK.tanzania),
      samoa: t(countryAutocompleteK.samoa),
      djibouti: t(countryAutocompleteK.djibouti),
      portugal: t(countryAutocompleteK.portugal),
      cambodia: t(countryAutocompleteK.cambodia),
      costaRica: t(countryAutocompleteK.costaRica),
      taiwan: t(countryAutocompleteK.taiwan),
      benin: t(countryAutocompleteK.benin),
      libya: t(countryAutocompleteK.libya),
    }),
    [i18n.language]
  );
};